import { Card } from '@/common'
import { ReportSectionCardHeader } from '../SectionCardHeader'
import { MethodEmissionReport } from '@/api/EmissionReportModel'
import { MethodCalculatedEmission } from '@/shared/api/types'
import MassBalanceReporting from './MassBalanceReporting'
import { useTranslation } from 'react-i18next'

export default function MassBalanceSection({
  reportId,
  methodEmissionReport: method,
  calculatedEmission,
  nextMethodEmissionReportId,
  isViewMode
}: {
  isComplete: boolean
  isViewMode: boolean
  reportId: string
  methodEmissionReport: MethodEmissionReport
  calculatedEmission?: MethodCalculatedEmission
  nextMethodEmissionReportId: string | null
  index: number
}) {
  const { t } = useTranslation()
  return (
    <Card>
      <ReportSectionCardHeader
        title={t('report:massBalance.title')}
        emissions={calculatedEmission?.massBalance || 0}
      />
      <MassBalanceReporting
        isViewMode={isViewMode}
        nextMethodEmissionReportId={nextMethodEmissionReportId}
        cnCodes={method.cnCodes}
        scrapInputItems={method.scrapInput || []}
        scrapOutputItems={method.scrapOutput || []}
        fuelItems={method.fuelInput || []}
        otherMaterialsInput={method.otherMaterialsInput || []}
        otherMaterialsOutput={method.otherMaterialsOutput || []}
        materialOutput={method.materialOutput || []}
        materialInput={method.materialInput || []}
        methodEmissionReportId={method.id}
        reportId={reportId}
        methodCalculatedEmission={calculatedEmission!}
      />
    </Card>
  )
}
